var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, Icon, Row, TextBody } from '../../atoms';
import { Tag } from '../../molecules';
import { accountTypeNames } from 'common';
function LocalListItem({ accountId, accountType, children, id, onPress, }) {
    var _a;
    // Handlers
    const handlePress = useCallback(() => {
        onPress(id, accountId);
    }, [accountId, id, onPress]);
    // Render
    return (_jsxs(Pressable, { onPress: handlePress, style: $.container, children: [_jsx(Col, { style: $.content, children: children }), _jsxs(Row.R, { style: $.addon, children: [_jsx(Tag, { label: (_a = accountTypeNames[accountType]) !== null && _a !== void 0 ? _a : accountType }), _jsx(Icon, { name: "ChevronRight" })] })] }));
}
export function StatementListItem(_a) {
    var { accountLabel, accountNumber } = _a, rest = __rest(_a, ["accountLabel", "accountNumber"]);
    return (_jsxs(LocalListItem, Object.assign({}, rest, { accountLabel: accountLabel, children: [_jsx(TextBody, { em: true, lhFull: true, children: accountLabel }), _jsx(TextBody, { small: true, lhFull: true, children: accountNumber })] })));
}
export function FundStatementListItem(_a) {
    var { accountLabel, accountNumber, fundName } = _a, rest = __rest(_a, ["accountLabel", "accountNumber", "fundName"]);
    return (_jsxs(LocalListItem, Object.assign({}, rest, { accountLabel: accountLabel, children: [_jsx(TextBody, { em: true, lhFull: true, children: fundName }), _jsxs(Row.L, { children: [_jsx(TextBody, { small: true, lhFull: true, children: accountLabel }), _jsx(Col, { style: $.textSeparator }), _jsx(TextBody, { small: true, lhFull: true, children: accountNumber })] })] })));
}
const $ = StyleSheet.create({
    container: {
        marginTop: theme.spacing['2'],
        padding: theme.spacing['4'],
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.color.background.tertiary,
        borderRadius: theme.radius.md,
    },
    content: {
        gap: theme.spacing['3'],
    },
    addon: {
        gap: theme.spacing['2'],
    },
    textSeparator: {
        backgroundColor: theme.color.border.primary,
        height: 9,
        width: 1,
        marginHorizontal: theme.spacing['2'],
    },
});
